import { Settings } from "@/shared/core/services/configService";

// The admin opens the course with ?preview=<token>: reads go to the preview endpoints and nothing is saved.
export function coursePreviewToken(route: any): string {
    return (route.query.preview as string) || "";
}

export function coursesApi(path: string, previewToken: string): string {
    return previewToken
        ? `${Settings.HostName}/api/public-courses/preview/${path}?t=${encodeURIComponent(previewToken)}`
        : `${Settings.HostName}/api/public-courses/${path}`;
}

export function coursePreviewRoute(path: string, previewToken: string): any {
    return previewToken ? { path, query: { preview: previewToken } } : path;
}
